<template>
  <!-- Section end -->
  <div class="tab-pane fade" id="writeoffs" role="tabpanel" aria-label="writeoffs-tab">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="row mb-2">
            <div v-if="customer" class="col-10 my-auto">
              <p class="d-inline font-weight-bold">Write-Off Reversal -</p>
              <p class="d-inline font-weight-bold">{{customer.CustomerName}}</p>
              <p class="d-inline font-weight-bold ml-1">( {{customer.CustomerReference}} )</p>
            </div>
            <div class="col-2 d-inline my-auto">
              <a
                class="btn btn-hc-nb float-right"
                role="button"
                data-toggle="modal"
                data-target="#addDebtWriteOff"
              >
                <img src="@/assets/img/add_icon_hcg.png" class="d-inline-block" alt="Add Icon" />
              </a>
            </div>
          </div>
          <hr />

          <div v-if="writeOffs && writeOffs.length > 0">
            <div class="row">
              <div class="col-12 my-auto">
                <div class="table-div mt-3">
                  <b-table
                    class="table-scroll tbl-sml"
                    striped
                    responsive
                    fixed
                    :items="writeOffs"
                    :fields="writeOffFields"
                  >
                    <template slot="HEAD_Select">
                      <span class="d-inline">
                        <label class="form-check-label radio_style">
                          <input
                            type="checkbox"
                            class="form-check-input radio_style"
                            v-model="allSelected"
                            @click="selectAll"
                          />
                          <span class="default"></span>
                        </label>
                      </span>
                    </template>

                    <template slot="Select" slot-scope="row">
                      <div>
                        <span class="d-inline">
                          <label class="form-check-label radio_style">
                            <input
                              v-model="row.item._rowSelected"
                              type="checkbox"
                              class="form-check-input radio_style"
                              @click="onRowSelected(row.item, row.index)"
                              :disabled="(!row.item._rowSelected && row.index != selected.length) || (row.item._rowSelected && row.index != (selected.length - 1))"
                            />
                            <span class="default"></span>
                          </label>
                        </span>
                      </div>
                    </template>

                    <template slot="Description" slot-scope="data">{{data.item.Description}}</template>

                    <template
                      slot="TaxPoint"
                      slot-scope="data"
                    >{{data.item.TaxPoint | moment('DD.MM.YY')}}</template>

                    <template slot="Gross" slot-scope="data">{{data.item.Gross | currency}}</template>

                    <template slot="Memo" slot-scope="data">{{data.item.Memo}}</template>
                  </b-table>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4 col-md-5 col-lg-4 col-xl-5">
                <p class="d-inline-block my-auto">Amount to reverse</p>
                <div class="input-group-prefix prefix">
                  <span class="input-group-addon">£</span>
                  <input type="number" step=".01" class="prefix pb-2 pt-2" v-model="reversalAmount" />
                </div>
              </div>
              <div class="col-sm-8 col-md-7 col-lg-8 col-xl-7">
                <p class="d-inline-block my-auto">Reason</p>
                <b-form-select class="mb-3" v-model="reversalReason">
                  <option :value="null"></option>
                  <option
                    v-for="(reason, index) in reversalReasons"
                    :key="index"
                    :value="reason"
                  >{{reason}}</option>
                </b-form-select>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <b-btn
                  role="button"
                  class="btn btn-hc float-right"
                  @click="reverseWriteOff"
                  :disabled="submitStatus == 'PENDING'"
                >Reverse</b-btn>
              </div>
            </div>
          </div>

          <div class="row" v-else>
            <div class="col-12">
              <div class="h-100">
                <div class="d-flex h-100 justify-content-center align-items-center mt-4">
                  <img src="@/assets/img/tick_selector.png" class="img-fluid d-inline-block" alt />
                  <p
                    class="d-inline-block my-auto pl-2"
                  >No written off debt eligible to be reversed for this account.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- main col-12 close -->
      </div>
      <!-- main row closed -->
    </div>
    <!-- container fluid close -->
  </div>
  <!-- tab pane close -->
</template>

<script>
import Vue from "vue";
import { _ } from "vue-underscore";
import _filters from "@/mixins/filters.js";

export default {
  mixins: [_filters],
  data() {
    return {
      submitStatus: null,
      writeOffFields: {
        Select: {
          label: "Select",
          sortable: true,
          class: "text-center col-1",
        },
        Description: {
          label: "Description",
          class: "col-3",
        },
        TaxPoint: {
          label: "Tax Point",
          class: "col-2",
        },
        Gross: {
          label: "Written Off",
          class: "col-2",
        },
        Memo: {
          label: "Reason",
          class: "col-4",
        },
      },
    };
  },
  computed: {
    customer() {
      return this.$store.state.customers.customer;
    },
    userEmail() {
      return this.$auth.decodedToken.payload.sub;
    },
    salesTransactions() {
      return this.$store.state.finances.salesTransactions;
    },
    writeOffs() {
      return _.sortBy(
        _.filter(
          _.where(this.salesTransactions, {
            Type: "DebtWriteOff",
          }),
          function(writeOff) {
            return !writeOff.hasOwnProperty("NextTransactionId");
          }
        ),
        "TaxPoint"
      ).reverse();
    },
    reasonRequired() {
      return Vue.config.honeycomb.writeOffs.reversalReasonRequired;
    },
    reversalReasons() {
      return Vue.config.honeycomb.writeOffs.reversalReasons;
    },
    totalWrittenOff() {
      var total = 0;
      this.writeOffs.forEach((writeOff) => {
        total += writeOff.Gross;
      });
      return total;
    },
    reversalAmount: {
      get() {
        return this.$store.state.finances.reversalAmount;
      },
      set(amount) {
        this.$store.commit("updateReversalAmount", amount);
      },
    },
    reversalReason: {
      get() {
        return this.$store.state.finances.reversalReason;
      },
      set(reason) {
        this.$store.commit("updateReversalReason", reason);
      },
    },
    selected: {
      get() {
        return this.$store.state.finances.selectedForReversal;
      },
      set(selected) {
        this.$store.commit("updateSelectedForReversal", selected);
      },
    },
    allSelected: {
      get() {
        return this.$store.state.finances.allSelectedForReversal;
      },
      set(bool) {
        this.$store.commit("updateAllSelectedForReversal", bool);
      },
    },
  },
  methods: {
    onRowSelected(item, index) {
      if (index == this.selected.length && !item._rowSelected) {
        this.selected.push(item);
        this.allSelected = false;
        if (this.selected.length == this.writeOffs.length) {
          this.allSelected = true;
        }
        this.$set(item, "_rowSelected", true);
        this.calculateReversalAmount();
        return;
      }
      if (index == this.selected.length - 1 && item._rowSelected) {
        this.selected.splice(index, 1);
        this.allSelected = false;
        this.$set(item, "_rowSelected", false);
        this.calculateReversalAmount();
        return;
      }
    },
    selectAll() {
      this.selected = [];
      if (!this.allSelected) {
        this.allSelected = true;
        this.writeOffs.forEach((writeOff) => {
          this.selected.push(writeOff);
          this.$set(writeOff, "_rowSelected", true);
        });
        this.calculateReversalAmount();
        return;
      }
      if (this.allSelected) {
        this.allSelected = false;
        this.writeOffs.forEach((writeOff) => {
          this.$set(writeOff, "_rowSelected", false);
        });
        this.calculateReversalAmount();
        return;
      }
    },
    calculateReversalAmount() {
      var total = 0;
      this.selected.forEach((writeOff) => {
        total += writeOff.Gross;
      });
      return (this.reversalAmount = total.toFixed(2));
    },
    reverseWriteOff() {
      if (this.selected.length == 0) {
        this.$snotify.warning(
          "Please select at least one write-off to be reversed."
        );
      }
      if (this.reversalAmount > this.totalWrittenOff) {
        this.$snotify.warning(
          "The amount to reverse must not be greater than the total amount written off."
        );
      }
      if (!this.reversalAmount || this.reversalAmount == 0) {
        this.$snotify.warning("Please provide an amount to reverse.");
      }
      if (this.reasonRequired && !this.reversalReason) {
        this.$snotify.warning(
          "Please select a reason for the write-off reversal."
        );
      }
      if (
        this.selected.length > 0 &&
        this.reversalAmount <= this.totalWrittenOff &&
        this.reversalAmount > 0 &&
        ((this.reasonRequired && this.reversalReason) || !this.reasonRequired)
      ) {
        this.submitStatus = "PENDING";
        this.reversalAmount = parseFloat(this.reversalAmount).toFixed(2);
        this.selected.forEach((writeOff) => {
          this.$http
            .post(
              "https://" +
                Vue.config.honeycomb.moneybot.domain +
                "/api/v1/salesTransactions/" +
                writeOff.Id +
                "/reverse",
              {
                AmountToReverse:
                  writeOff.Gross < this.reversalAmount
                    ? writeOff.Gross
                    : this.reversalAmount,
                CreatedBy: this.userEmail,
                RelatedTransactionId: writeOff.Id,
                Memo: this.reversalReason,
                WriteOffOrBack: false,
              },
              {
                withCredentials: true,
              }
            )
            .then(() => {
              if (writeOff.Gross < this.reversalAmount) {
                this.reversalAmount -= writeOff.Gross;
              } else {
                this.reversalAmount = null;
              }
              this.$snotify.success(
                `${writeOff.Description} has been reversed.`
              );
            })
            .catch((error) => {
              if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                this.submitStatus = "Error";
                this.$snotify.error(
                  error.response.data.MoreInformation[0].Error,
                  {
                    timeout: 0,
                    closeOnClick: true,
                  }
                );
              } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                this.submitStatus = "Error";
                this.$snotify.error("No response recieved.", {
                  timeout: 0,
                  closeOnClick: true,
                });
              } else {
                // Something happened in setting up the request that triggered an Error
                this.submitStatus = "Error";
                this.$snotify.error(error.message, {
                  timeout: 0,
                  closeOnClick: true,
                });
              }
            });
        });
        setTimeout(() => {
          this.submitStatus = "OK";
          this.$store.dispatch("getLedger");
          this.$store.dispatch("getSalesTransactions");
          this.reversalAmount = null;
          this.reversalReason = null;
          this.allSelected = false;
          this.selected = [];
        }, 1800);
      }
    },
  },
};
</script>
